export default "__VITE_ASSET__X5j0P2rQ__"